// Package imports:
import React, { useContext, useEffect, useState } from 'react';
// Component imporst:
import HlutabrefComp from '../../components/Hlutabref/Hlutabref';
// Type imports:
import { IDefaultProps } from '../../types/Types';
// Context imports:
import AccessTokenContextProvider, { AccessTokenContext } from '../../contexts/AccessTokenContext';

const HlutabrefWrapper = () => {
    const accessToken = useContext(AccessTokenContext);
    const [ defaultProps, setDefaultProps ] = useState<IDefaultProps>({
        accessToken,
        refreshRateMs: 60*1000
    });

    useEffect(() => {
        setDefaultProps({
            ...defaultProps,
            accessToken
        });
    }, [accessToken]);

    return (
        <HlutabrefComp {...defaultProps} />
    )
}

const Hlutabref: React.FC = () => {
    return (
        <AccessTokenContextProvider>
            <HlutabrefWrapper />
        </AccessTokenContextProvider>
    );
}

export default Hlutabref;